import "../Styles/main.scss";
import "./index.scss";
import "../../components/cmsShared";
import "jquery.cookie";
import { assert } from "@/common/assert";
import { IS_PROD } from "@/common/fhtGlobalEnv";

// 导航栏打开关闭
const height = $(window).height();
const $body = $("html, body");
const $menubar = $(".header__menubar");

$(".navbar-toggle").click(function () {
    if ($menubar.is(":hidden")) {
        $menubar.show();
        $body.addClass("stop-scrolling");
    } else {
        $menubar.hide();
        $body.removeClass("stop-scrolling");
    }
    $(this).toggleClass("close-navbar");
});

$(".product-center").click(function(){
    $.cookie('fht_product_sort',"",{ expires:1});
});

//导航初始化
const $hasChildren = $(".m-navigation__item--has-child");
const $childNavList = $(".m-navigation__children");

function assertValidState() {
    if (!IS_PROD) {
        assert($(".m-navigation__item--active").length <= 1, "should not have more than 1 active nav item");
        const $hasActiveChild = $(".m-navigation__item--has-child .m-navigation__item--active");
        $(".m-navigation__child-item").each(function (idx, el) {
            assert($(el).closest(".m-navigation__item").is(".m-navigation__item--has-child"));
        });
        assert($hasActiveChild.length <= 1, "should not have more than 1");
        if ($hasActiveChild.length) {
            assert(
                $hasActiveChild.closest(".m-navigation__item--has-child").is(".m-navigation__item--is-active-parent"),
                "must be active parent",
            );
        }
    }
}

$(function () {
    assertValidState();
    const $activeParent = $(".m-navigation__item--is-active-parent");
    assert($activeParent.length <= 1, "should not have more than 1 active parent");

    //导航初始化
    const $activeItem = $(".m-navigation__item--active");
    //二级导航active，展开二级列表
    $activeParent.addClass("m-navigation__children--expanded");

    //点击一级导航箭头当前二级导航展开（闭合）
    const $navIcon = $(".m-navigation__post-link");
    $navIcon.on("click", function () {
        if ($hasChildren.hasClass("m-navigation__children--expanded")) {
            $childNavList.slideUp(300);
            $hasChildren.removeClass("m-navigation__children--expanded");
        } else {
            $childNavList.slideDown(300);
            $hasChildren.addClass("m-navigation__children--expanded");
        }
        assertValidState();
    });
});

//点击关闭导航
$menubar.css("height", height);
const $navClose = $(".close-navbar");
$navClose.on("click", function () {
    $(".header__menubar").hide();
    $(".navbar-toggle").removeClass("close-navbar");
    $("body,html").removeClass("stop-scrolling");
});

/*********  手动滑动导航 ***********/

$(function () {
    const menu = function (wrap: any, menuList: any, menuItems: any) {
        const deviceWidth = $(window).width();
        let positionX = 0;
        const menuListPositionX1 = wrap.offset()!.left;
        const menuListPositionX2 = menuListPositionX1 + wrap.width();
        let transformX = 0;
        let thisWidth = 0;
        $(menuList).attr("style", "transition-duration: 0ms;transform: translateX(0px);");

        menuList.addEventListener(
            "touchstart",
            function (event: any) {
                if (event.targetTouches.length === 1) {
                    const touch = event.targetTouches[0];
                    positionX = touch.pageX;
                    //确定本次拖动transform的初始值
                    let transformStr = menuList.style.transform;
                    transformStr = transformStr.substring(11);
                    const index = transformStr.lastIndexOf("p");
                    transformStr = transformStr.substring(0, index);
                    // eslint-disable-next-line no-restricted-syntax
                    transformX = parseInt(transformStr);
                    //确定本次拖动的div宽度值
                    const widthStr = menuList.style.width;
                    // eslint-disable-next-line no-restricted-syntax
                    thisWidth = parseInt(widthStr.substring(0, widthStr.lastIndexOf("p")));
                }
            },
            false,
        );
        menuList.addEventListener(
            "touchmove",
            function (event: any) {
                //阻止其他事件
                event.preventDefault();
                //获取当前坐标
                if (event.targetTouches.length === 1) {
                    const touch = event.targetTouches[0];
                    menuList.style.transform = "translateX(" + (transformX + touch.pageX - positionX) + "px)";
                    $(menuList).css("width", thisWidth + positionX - touch.pageX);
                }
            },
            false,
        );
        menuList.addEventListener(
            "touchend",
            function (event: any) {
                const menuItem1 = menuItems[0];
                const menuItem1Left = $(menuItem1).offset()!.left;
                const menuItem2 = menuItems[menuItems.length - 1];
                const menuItemPositionX = $(menuItem2).offset()!.left + $(menuItem2).width();
                const firstToLast = menuItemPositionX - menuItem1Left;
                if (menuItem1Left > menuListPositionX1 || firstToLast < deviceWidth) {
                    menuList.style.transform = "translateX(" + menuListPositionX1 + "px)";
                }
                if (menuItemPositionX < menuListPositionX2 && menuItem1Left < 0 && firstToLast > deviceWidth) {
                    const myWidth = $(menuList).width() - deviceWidth;
                    menuList.style.transform = "translateX(" + (0 - myWidth) + "px)";
                }
            },
            false,
        );
    };

    const event = function () {
        $("#menu-wrap .js-menu-list span").click(function () {
            console.log($(this).attr("data-index"));
            const activeMenu = $(".js-menu-wrap" + $(this).attr("data-index"));
            activeMenu.siblings().hide();
            activeMenu.show();
        });
    };
    const init = (function () {
        const menuWrap = $("#menu-wrap");
        const menuList = $("#menu-wrap .js-menu-list")[0];
        const menuListItems = $("#menu-wrap .menu-list-item");
        // menu(menuWrap, menuList, menuListItems);
        // event();
    })();
});
